import {DtrackProject, Finding, ProjectMetrics} from './type';
import { createApiRef } from '@backstage/core-plugin-api';
import { Entity } from '@backstage/catalog-model';

export const dtrackApiRef = createApiRef<DtrackApi>({
    id: 'plugin.dtrack.service',
});

export interface DtrackApi {
    fetchProject(
        entity: Entity,
        env: string,
    ): Promise<DtrackProject>;

    fetchFindings(
        entity: Entity,
        env: string,
    ): Promise<Finding[]>;

    fetchMetrics(
        entity: Entity,
        env: string,
    ): Promise<ProjectMetrics>;

    getDtrackGraph(
        entity: Entity,
        env: string,
    ): Promise<Object>;
}